import './ghost.component.scss';

interface Props {
  displayType: 'scroll' | 'grid';
  maxWidth: boolean;
  titleSize: string;
  title: string;
  description: string;
  showVideoTitle: boolean;
  showVideoArtist: boolean;
  loadingBackground: string;
}

export function Ghost({
  displayType,
  maxWidth,
  titleSize,
  title,
  description,
  showVideoTitle,
  showVideoArtist,
  loadingBackground,
}: Props) {
  const ghostCards = [0, 1, 2, 3];
  const sectionClass =
    'single-content-section' + (displayType === 'grid' && maxWidth ? ' page-width' : '');

  return (
    <div class="ghost-wrapper" style={{ '--loadingBackground': loadingBackground }}>
      <section class={sectionClass}>
        <h2 class={`title ghost video-collection-title ${titleSize || ''}`.trim()}>{title}</h2>

        {description && (
          <p
            class="ghost video-collection-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        <div class="ghost-grid single-grid single-video-grid">
          <div class="single-grid-item">
            {ghostCards.map((_, i) => (
              <div class="single-card-video animate-flicker" key={i}>
                <div class="single-card-image-wide">&nbsp;</div>
                {(showVideoTitle || showVideoArtist) && (
                  <div class="single-video-info">
                    {showVideoTitle && <h4 class="single-video-title">&nbsp;</h4>}
                    {showVideoArtist && <h6 class="single-video-description">&nbsp;</h6>}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
